import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const reverseTransform = archive => ({ ...removeExtraSubFieldsHelper(archive, ['picture', 'cards', 'medium']) });

export { reverseTransform };
